import { render } from "./NonProfitFooter.vue?vue&type=template&id=46329242&scoped=true"
import script from "./NonProfitFooter.vue?vue&type=script&lang=js"
export * from "./NonProfitFooter.vue?vue&type=script&lang=js"

import "./NonProfitFooter.vue?vue&type=style&index=0&id=46329242&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46329242"]])

export default __exports__